const styles = () => ({
  loadWrapper: {
    backgroundColor: 'white',
    opacity: 0.9,
    display: 'flex',
    position: 'absolute',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    top: 0,
    flexDirection: 'column',
    zIndex: 2,
  },
  loadMessage: {
    marginTop: 20,
    fontFamily: 'Roboto-Bold',
    opacity: 0.85,
    lineHeight: 1.8,
    textAlign: 'center'
  },
});

export default styles;